import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { CreateSSOProvider, PublicSSOProvider, SSOProvider, SSOProviderListResponse, SSOProviderQueryParams, UpdateSSOProvider } from '@frontend/sso/types';

export class SSOProviderClient extends APIClient {
    public static readonly endpoint = '/sso-api/v1';

    public static async fetchProviderByDomain(domain?: string): Promise<PublicSSOProvider> {
        const response = await this.fetch(`${this.endpoint}/domains/${domain || window.location.hostname}`, undefined, false);
        return await this.handleResponse<PublicSSOProvider>(response);
    }

    public static async fetchProviders(queryParams?: ApiQueryParams<DefaultQueryParams | SSOProviderQueryParams>): Promise<SSOProviderListResponse> {
        return await this.apiPaginated<SSOProviderListResponse, DefaultQueryParams>(`${this.endpoint}/providers`, queryParams);
    }

    public static async resolveSSOProviders(ids: string[], field: keyof SSOProvider = 'id'): Promise<SSOProviderListResponse> {
        const response = await this.post(`${this.endpoint}/providers-resolve`, { field, ids: ids });
        return await this.handleResponse<SSOProviderListResponse>(response);
    }

    public static async deleteSSProviders(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/providers-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postSSOProvider(accountId: string, provider: CreateSSOProvider): Promise<SSOProvider> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/providers`, provider);
        return await this.handleResponse<SSOProvider>(response);
    }

    public static async fetchSSOProvider(accountId: string, id: string): Promise<SSOProvider> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/providers/${id}`);
        return await this.handleResponse<SSOProvider>(response);
    }

    public static async patchSSOProvider(accountId: string, id: string, provider: UpdateSSOProvider): Promise<SSOProvider> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/providers/${id}`, provider);
        return await this.handleResponse<SSOProvider>(response);
    }

    public static async deleteSSOProvider(accountId: string, id: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/providers/${id}`);
        return await this.handleVoidResponse(response);
    }
}
